import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, sitConfig } from './config'
import { getFormattedDate } from './eosCreateWorkItem'

const responseParser = (response: any) => {
  return response
}

const getData = (auditType: string, dataToManipulate: any, identificationNumber: string, makerComments: string) => {
  return auditType === 'CIN'
    ? { businessProfile: dataToManipulate }
    : auditType === 'AUTHORISED_SIGNATORY'
    ? { authorisedSignatory: dataToManipulate }
    : auditType === 'DIRECTOR'
    ? { directorDetails: dataToManipulate }
    : auditType === 'UBO'
    ? { beneficialOwnerDetails: dataToManipulate }
    : auditType === 'AADHAR_REDACTION'
    ? {
        filterType: 'AADHAR_REDACTION',
        aadharRedaction: {
          uploadId: dataToManipulate,
          identificationNumber: identificationNumber,
          makerComments: makerComments,
        },
      }
    : {}
}

const createUpdateDeleteFiu = (
  identificationNumber: string,
  auditType: string,
  dataToManipulate: any,
  makerComments: string,
  tokens: any,
) => {
  const request: JFSRequest<{}> = {
    apiPath: auditType === 'AADHAR_REDACTION' ? APIEndPoints.aadharRedactionInit : APIEndPoints.createUpdateDeleteFiu,
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      applicationId: `NEW-${getFormattedDate()}`,
      ...(auditType !== 'AADHAR_REDACTION' && { identificationNumber: identificationNumber }),
      ...(auditType !== 'AADHAR_REDACTION' && { auditType: auditType }),
      ...getData(auditType, dataToManipulate, identificationNumber, makerComments),
      requestType: 'AUDIT',
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { createUpdateDeleteFiu }
